import { Box, InfoIcon, Text, Tooltip } from 'edenred-ui';
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import { useTheme } from '@mui/material';

export const EstimationFeeDescription = () => {
  const { t } = useTranslation();
  const { primaryFrontColor } = useTheme();

  return (
    <Box display="flex" alignItems="center" textAlign="right">
      {t('containers.deposit_money.commission.message')}

      <Tooltip
        arrow
        placement="top"
        title={
          <Box maxWidth={274} p={2}>
            <Text>
              <Trans
                i18nKey={'containers.deposit_money.commission.tooltipMessage'}
              />
            </Text>
          </Box>
        }
      >
        <Box paddingLeft="4px">
          <InfoIcon color={primaryFrontColor} />
        </Box>
      </Tooltip>
    </Box>
  );
};
